import z from 'zod';
import { zodQueryBoolean } from './boolean.types.js';
export var AccountingReportReconciliationType;
(function (AccountingReportReconciliationType) {
    AccountingReportReconciliationType["All"] = "all";
    AccountingReportReconciliationType["OnlyReconciled"] = "onlyReconciled";
})(AccountingReportReconciliationType || (AccountingReportReconciliationType = {}));
export var AccountingGeneralReportType;
(function (AccountingGeneralReportType) {
    AccountingGeneralReportType["GeneralLedger"] = "generalLedger";
    AccountingGeneralReportType["SubLedger"] = "subLedger";
    AccountingGeneralReportType["Balance"] = "Balance";
    AccountingGeneralReportType["SubledgerBalance"] = "subledgerBalance";
    AccountingGeneralReportType["ComparativeBalanceWithPreviousPeriod"] = "comparativeBalanceWithPreviousPeriod";
    AccountingGeneralReportType["ComparativeBalance"] = "comparativeBalance";
    AccountingGeneralReportType["GeneralStatement"] = "generalStatement";
    AccountingGeneralReportType["IncomeStatement"] = "incomeStatement";
})(AccountingGeneralReportType || (AccountingGeneralReportType = {}));
export const accountingReportGeneralExportSchema = z.object({
    accountingPeriodId: z.coerce.number().min(1, "L'exercice est requis"),
    reconciliationType: z.enum(AccountingReportReconciliationType),
    startDate: z.coerce.date({ message: 'La date de début est requise' }),
    endDate: z.coerce.date({ message: 'La date de fin est requise' }),
    startAccountCode: z.string().min(1).optional(),
    endAccountCode: z.string().min(1).optional(),
    dueStartDate: z.coerce.date({ message: "La date d'échéance de début est requise" }),
    dueEndDate: z.coerce.date({ message: "La date d'échéance de fin est requise" }),
    includeUnvalidatedTransactions: zodQueryBoolean(),
    includeInactiveAccounts: zodQueryBoolean(),
    showOnlyAccountsWithTransactions: zodQueryBoolean(),
    reportTypes: z.array(z.enum(AccountingGeneralReportType)).min(1, 'Le type de rapport est requis'),
});
export var AccountingAnalyticsReportType;
(function (AccountingAnalyticsReportType) {
    AccountingAnalyticsReportType["Budget"] = "budget";
    AccountingAnalyticsReportType["DetailedBudget"] = "detailedBudget";
    AccountingAnalyticsReportType["AnalyticalBalance"] = "analyticalBalance";
    AccountingAnalyticsReportType["DetailedAnalyticalBalance"] = "detailedAnalyticalBalance";
    AccountingAnalyticsReportType["AnalyticalGeneralLedger"] = "analyticalGeneralLedger";
})(AccountingAnalyticsReportType || (AccountingAnalyticsReportType = {}));
export const accountingReportAnalyticsExportSchema = z.object({
    accountingPeriodId: z.coerce.number().min(1, "L'exercice est requis"),
    reconciliationType: z.enum(AccountingReportReconciliationType),
    startDate: z.coerce.date({ message: 'La date de début est requise' }),
    endDate: z.coerce.date({ message: 'La date de fin est requise' }),
    startAccountCode: z.string().min(1).optional(),
    endAccountCode: z.string().min(1).optional(),
    includeUnvalidatedTransactions: zodQueryBoolean(),
    includeInactiveAccountsAndInactiveCodes: zodQueryBoolean(),
    showOnlyAccountsAndCodesWithTransactions: zodQueryBoolean(),
    reportTypes: z
        .array(z.enum(AccountingAnalyticsReportType))
        .min(1, 'Le type de rapport est requis'),
});
export var AccountingManagementReportType;
(function (AccountingManagementReportType) {
    AccountingManagementReportType["AepDevelopedViaAnalytics"] = "aepDevelopedViaAnalytics";
    AccountingManagementReportType["AepDevelopedViaGeneralAccounting"] = "aepDevelopedViaGeneralAccounting";
    AccountingManagementReportType["Beneficiaries"] = "beneficiaries";
    AccountingManagementReportType["AscSummary"] = "ascSummary";
    AccountingManagementReportType["AscDevelopedByCommission"] = "ascDevelopedByCommission";
    AccountingManagementReportType["AscDevelopedByAttachmentCode"] = "ascDevelopedByAttachmentCode";
    AccountingManagementReportType["AscDetailedByService"] = "ascDetailedByService";
    AccountingManagementReportType["PatrimoineDuCe"] = "patrimoineDuCe";
    AccountingManagementReportType["SignificantTransactions"] = "significantTransactions";
    AccountingManagementReportType["AscSubventionsBilletterie"] = "ascSubventionsBilletterie";
})(AccountingManagementReportType || (AccountingManagementReportType = {}));
export const accountingReportManagementExportSchema = z.object({
    accountingPeriodId: z.coerce.number().min(1, "L'exercice est requis"),
    startDate: z.coerce.date({ message: 'La date de début est requise' }),
    endDate: z.coerce.date({ message: 'La date de fin est requise' }),
    reportTypes: z
        .array(z.enum(AccountingManagementReportType))
        .min(1, 'Le type de rapport est requis'),
});
/** Response header of a file export that went out degraded; URI-encoded French copy. */
export const EXPORT_WARNING_HEADER = 'X-Export-Warning';
